import { render, staticRenderFns } from "./Visitor.vue?vue&type=template&id=fbb224c2"
import script from "./Visitor.vue?vue&type=script&lang=js"
export * from "./Visitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports